var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBgType1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 800,
    height: 1900,
    viewBox: "0 0 800 1900",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-BG_type1_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 1900
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BG_type1_1",
    "data-name": "BG_type1 \\u2013 1",
    clipPath: "url(#clip-BG_type1_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 1900,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_170",
    "data-name": "Group 170",
    transform: "translate(-185 -142)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_151",
    "data-name": "Rectangle 151",
    width: 839,
    height: 1819,
    transform: "translate(155 142)",
    fill: "#006"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_70",
    "data-name": "Ellipse 70",
    cx: 107,
    cy: 106.5,
    rx: 107,
    ry: 106.5,
    transform: "translate(866 630)",
    fill: "#6ee7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_359",
    "data-name": "Path 359",
    d: "M48.667,6.921Q53.041.893,57.97.079T72.2,6.921q3.823,4.374,10.124,10.4,6.284,6.015,13.134,13.407t14.5,15.6q7.657,8.209,14.776,16.418a19.307,19.307,0,0,1,5.473,10.4q1.088,6.016-3.284,12.04L84.238,152.489q-3.282,4.926-5.746,6.293a4.872,4.872,0,0,1-4.378.548,13.709,13.709,0,0,1-4.1-3.01,41.712,41.712,0,0,0-4.378-3.831L2.7,101.047q-4.386-4.386-1.642-11.218A90.407,90.407,0,0,1,8.171,75.874q10.39-19.163,20.248-36.94A302.457,302.457,0,0,1,48.667,6.921",
    transform: "translate(312.307 1516.69) rotate(-31)",
    fill: "#ff1335"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_356",
    "data-name": "Path 356",
    d: "M214.588,30.514Q233.873,3.937,255.607.35q21.72-3.615,62.738,30.164Q335.2,49.8,362.986,76.361q27.709,26.522,57.91,59.116,30.144,32.579,63.945,68.771,33.762,36.2,65.151,72.39a85.13,85.13,0,0,1,24.131,45.844q4.8,26.525-14.48,53.087L371.429,672.362q-14.47,21.72-25.335,27.747c-7.237,4-13.683,4.829-19.3,2.417-5.657-2.417-11.687-6.863-18.1-13.272a183.923,183.923,0,0,0-19.3-16.892L11.9,445.544q-19.34-19.337-7.239-49.465a398.63,398.63,0,0,1,31.368-61.53q45.81-84.494,89.278-162.878,43.437-78.434,89.282-141.157",
    transform: "translate(-133.026 370.026)",
    fill: "#fde047"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_71",
    "data-name": "Ellipse 71",
    cx: 550,
    cy: 550,
    r: 550,
    transform: "translate(378 754)",
    fill: "#0000af"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_72",
    "data-name": "Ellipse 72",
    cx: 213.5,
    cy: 212.5,
    rx: 213.5,
    ry: 212.5,
    transform: "translate(-114 -123)",
    fill: "#0000af"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_73",
    "data-name": "Ellipse 73",
    cx: 353.5,
    cy: 353,
    rx: 353.5,
    ry: 353,
    transform: "translate(48 1568)",
    fill: "#6ee7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_358",
    "data-name": "Path 358",
    d: "M385.559,54.826q34.651-47.752,73.7-54.2,39.026-6.5,112.725,54.2,30.287,34.651,80.206,82.374,49.785,47.653,104.049,106.216Q810.4,301.951,871.132,366.98q60.662,65.037,117.059,130.066,34.645,34.65,43.358,82.37,8.622,47.659-26.017,95.384L667.361,1208.062q-26,39.025-45.521,49.855c-13,7.181-24.584,8.676-34.682,4.342-10.164-4.342-21-12.331-32.515-23.846a330.491,330.491,0,0,0-34.685-30.351L21.378,800.528q-34.75-34.744-13.007-88.875Q30.02,657.387,64.732,601.1q82.31-151.815,160.409-292.65Q303.187,167.522,385.559,54.826",
    transform: "translate(434.904 1210.862)",
    fill: "#006"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_357",
    "data-name": "Path 357",
    d: "M122.451,17.412Q133.455,2.247,145.857.2q12.394-2.063,35.8,17.213,9.619,11,25.473,26.161,15.811,15.134,33.045,33.733,17.2,18.59,36.489,39.243,19.266,20.655,37.177,41.308a48.578,48.578,0,0,1,13.77,26.16q2.738,15.136-8.263,30.293l-107.4,169.36q-8.257,12.394-14.457,15.834c-4.13,2.281-7.808,2.756-11.015,1.379a34.489,34.489,0,0,1-10.326-7.573,104.957,104.957,0,0,0-11.016-9.639L6.79,254.241q-11.036-11.034-4.131-28.226a227.469,227.469,0,0,1,17.9-35.111Q46.7,142.689,71.5,97.961a761,761,0,0,1,50.947-80.548",
    transform: "translate(843.987 169.199)",
    fill: "#ff1335"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_363",
    "data-name": "Path 363",
    d: "M81.061,11.527Q88.346,1.487,96.556.132t23.7,11.394q6.368,7.285,16.863,17.318,10.467,10.019,21.875,22.331,11.387,12.307,24.155,25.978T207.759,104.5a32.158,32.158,0,0,1,9.116,17.317q1.813,10.02-5.47,20.054l-71.1,112.113q-5.466,8.2-9.57,10.482c-2.734,1.51-5.169,1.824-7.291.913a22.831,22.831,0,0,1-6.836-5.013,69.482,69.482,0,0,0-7.292-6.381L4.5,168.3q-7.306-7.3-2.735-18.685A150.582,150.582,0,0,1,13.61,126.376q17.3-31.918,33.725-61.527A503.768,503.768,0,0,1,81.061,11.527",
    transform: "translate(735.37 1880.33)",
    fill: "#fde047"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgType1);
export default __webpack_public_path__ + "static/media/bg_type1.7d4bf4a16df1e088d34d6eedf35fdc6a.svg";
export { ForwardRef as ReactComponent };